/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FileTypeTableIcon24Solid = forwardRef('FileTypeTableIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.201 2.879A3 3 0 0 0 13.08 2H8a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h8a4 4 0 0 0 4-4V8.92a3 3 0 0 0-.879-2.121l-3.92-3.92ZM6 9a1 1 0 0 1 1-1h2V5a1 1 0 0 1 2 0v3h6a1 1 0 1 1 0 2h-6v9a1 1 0 1 1-2 0v-9H7a1 1 0 0 1-1-1Z" })));
});
